._preset-snapshot-warpper_8g1sc_1 {
  display: grid; }
  ._preset-snapshot-warpper_8g1sc_1 ._preset-snapshot-image_8g1sc_3 {
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    align-self: center; }
